import { FC } from "react"

import { Button } from "@mui/material"
import { useTranslation } from "react-i18next"

interface IProps {
  // Outlined on tablet+, text on mobile — matches the sibling transaction buttons.
  isTablet: boolean
  onClick: () => void
}

const StoreChargeEntryButton: FC<IProps> = ({ isTablet, onClick }) => {
  const { t } = useTranslation()

  return (
    <Button
      variant={isTablet ? "outlined" : "text"}
      sx={{ whiteSpace: "nowrap", flexShrink: 0 }}
      onClick={onClick}
    >
      {t("storeCharge.entryLabel")}
    </Button>
  )
}

export default StoreChargeEntryButton
